<template>
    <b-card-body v-if="result">
        
        <table class="table table-md mb-3">
            <thead>
                <tr>
                    <th>Customers</th>
                    <th>Customers with multiple orders</th>
                    <th>Resale rate</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{result.customers}}</td>
                    <td>{{result.hasOrders}}</td>
                    <td>{{result.data}}%</td>
                </tr>
            </tbody>
        </table>

    </b-card-body>
</template>

<script>
import mixin from "../../mixins/area";

export default {
    data: () => ({
        result: null,
    }),
    components: {  },
    watch: {
        entity: {
            deep: true,
            handler() {
                this.getResult();
            }
        }
    },
    computed: {},
    methods: {
        getResult() {
            this.$http.post("/api/module/dashboard/resale", {
                dates: this.entity.dates,
                user: this.entity.user,
                franchise: this.entity.franchise
            }).then(x => {
                this.result = x.data;
            });
        },
    },
    created() {
        this.getResult();
    },
    mounted() {

    },
    mixins: [mixin]
};
</script>

<style lang="scss">


</style>